// Wave 10 - a "group" is a CTA template (ICtaTemplateApi / FormGroup<ICtaForm>). "Global" is the
// literal isAllCreators flag; "shared" isn't a stored flag at all - it's a custom (isAllCreators:
// false) group used by 2+ creators, computed on the fly (mirrors CreatorsAndCtasService's own
// getGlobalAndSharedCtas() threshold). Per product decision, "shared" counts as "global" for event
// classification purposes (fires the global_group_* family), even though isAllCreators stays false.
export type TGroupCategory = 'custom' | 'shared' | 'global';

export function getGroupCategory(isAllCreators: boolean | null | undefined, creatorCount: number): TGroupCategory {
  if (isAllCreators) {
    return 'global';
  }

  return creatorCount > 1 ? 'shared' : 'custom';
}

export function isGlobalGroupFamily(category: TGroupCategory): boolean {
  return category !== 'custom';
}
